import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {WebPViaServerDialogComponent} from "../../dialogs/webp-via-server-dialog/webp-via-server-dialog.component";
import {DbModalService} from "../../../../../modules/modal/modal";
import {first, takeUntil} from "rxjs/operators";
import {BoosterService} from "../../services/booster.service";
import {FormControl, FormGroup} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../../user/user-subscription";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {ActivatedRoute, Router} from "@angular/router";
import {IBoosterStats} from "../../../../../store/reducers/booster.reducer";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {Website} from "../../../website";

@Component({
    selector: 'db-image-optimizer-webp',
    templateUrl: './image-optimizer-webp.component.html',
    styleUrls: ['./image-optimizer-webp.component.scss'],
    standalone: false
})
export class ImageOptimizerWebpComponent implements OnInit, OnDestroy {

  @Input() currentSubscription: UserSubscription;
  @Input() website: Website;
  @Input() websiteId: number;
  @Input() boosterPluginIsActive: boolean;
  @Input() ioPluginIsActive: boolean;

  public boosterSettings: any;
  public websiteHosted: boolean;
  public websiteServerType: string;
  public imageOptimizerSettings: FormGroup = new FormGroup({
    'autoOptimize': new FormControl(null),
    'webpStatus': new FormControl(null),
    'pictureWebpStatus': new FormControl(null)
  });
  public loading: boolean = true;
  public stats: IBoosterStats;
  public error: boolean = false;
  public webpServerConfigIsActive: boolean = true;
  public pageLayout: boolean = false;
  public loadingWebpFormat: boolean = false;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _router: Router,
    private _dbModal: DbModalService,
    private _boosterService: BoosterService,
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _route: ActivatedRoute,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnInit() {
    this._initData();
    !!this.boosterPluginIsActive  && this._addEventHandlers();
    if(!this.boosterPluginIsActive) this.loading = false;
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  public setWebpStatus(): void {
    this.loadingWebpFormat = true;
    this._boosterService.setWebpStatus(this.websiteId, this.imageOptimizerSettings.value.webpStatus, this.imageOptimizerSettings.value.pictureWebpStatus)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(() => {
        this._store.dispatch(new fromStore.LoadBoosterData({websiteId: this.websiteId}));
        this.loadingWebpFormat = true;
      });
  }

  public showWebPServerDialog(): void {
    const modal = this._dbModal.open(WebPViaServerDialogComponent);
    modal.componentInstance.serverType = this.websiteServerType;
  }

  public getWebpStatus(): void {
    this.loadingWebpFormat = true;
    this._store.dispatch(new fromStore.LoadBoosterData({websiteId: this.websiteId}));
    setTimeout(() => {
      NotifierComponent.notify(new Notification('Webp status checked successfully', NotificationType.SUCCESS));
      this.loadingWebpFormat = false;
    }, 3000);
  }

  private _initData(): void {
    this.pageLayout = this._route.snapshot.data['pageId'] === 'image-optimizer';
    this.websiteHosted = !!this.website.domain_hash;
    this.websiteServerType = this.website.serverType;
  }

  private _addEventHandlers(): void {
    this._getBoosterSettings();
  }

  private _getBoosterSettings(): void {
    this._store.select(fromStore.getWebsiteWebpStatus(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(webpStatus => {
        if (!TypeUtils.isNull(webpStatus)) {
          this.loadingWebpFormat = false;
          this.loading = false;
          this.boosterSettings = webpStatus;
          this.imageOptimizerSettings.controls['webpStatus'].setValue(TypeUtils.isDefined(this.boosterSettings.webpStatus) ? this.boosterSettings.webpStatus : false);
          this.imageOptimizerSettings.controls['pictureWebpStatus'].setValue(TypeUtils.isDefined(this.boosterSettings.pictureWebpStatus) ? this.boosterSettings.pictureWebpStatus : false);
          this.webpServerConfigIsActive = TypeUtils.isDefined(this.boosterSettings) && !TypeUtils.isNull(this.boosterSettings) && TypeUtils.isDefined(this.boosterSettings.webpStatus) && !this.boosterSettings.webpStatus
            && TypeUtils.isDefined(this.boosterSettings.webpDeliveryWorking) && !!this.boosterSettings.webpDeliveryWorking;
        }
      });
  }

}
